import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { AppBar, Box, IconButton, Toolbar, useTheme } from '@mui/material';
import { Menu } from '@mui/icons-material';

import { AppLogo, NavList } from 'components';
import { desktopHeaderMenuConfig } from 'configs';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';

interface UnauthHeaderLayoutProps {}

export const UnauthHeaderLayout: React.FC<UnauthHeaderLayoutProps> = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      color="inherit"
      sx={{
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)',
        borderTop: `4px solid ${theme.palette.primary.main}`,
      }}
    >
      <Toolbar>
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <AppLogo />

          <Box display={{ xs: 'flex', md: 'none' }}>
            <IconButton
              color="primary"
              onClick={() => {
                dispatch(
                  updateLayout({
                    unauthSidebarMenuOpened: true,
                  }),
                );
              }}
            >
              <Menu />
            </IconButton>
          </Box>

          <NavList
            navItems={desktopHeaderMenuConfig}
            activeLink={location.pathname}
            navItemStyle={{
              paddingX: 3,
            }}
            display={{ xs: 'none', md: 'flex' }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
